// Keys under which the theme is stored through the user preferences API.
export const THEME_PRIMARY_COLOR_KEY = 'theme.primaryColor'
export const THEME_SCHEME_KEY = 'theme.scheme'

// Profile name `{ firstName, lastName }`. Absent until the user saves it.
export const FULL_NAME_KEY = 'fullName'

// Staff-only data provider choice (`DataProviderChoice`). Read on the server, so the
// page mints the matching Embeddable token. The key keeps its original name, from
// when it only switched staging on (`'true'`), so stored choices carry over.
export const DATA_PROVIDER_KEY = 'dashboard.stagingDataProvider'
